module.exports = __webpack_public_path__ + "assets/d80484095e030fdbd57d24debeed24a1.mp3";